var ajax = require('./tripletrax.ajax.js');

function registerStatsEvents() {

    // Auswahl Abfragen - Anzeige der gewählten Abfrage
    $('body').on('change', '.tt-stats-filter', function (e) {

        $(this).parents('.tt-content-datatable').find('.tt-datatable,.tt-datatable-detail').DataTable().draw();
    });

    $('body').on('click', '.tt-stats-export', function(e) {
        e.preventDefault();

        $('.tt-please-wait-export-visits').removeClass('hide');
        var element = $(this);
        element.attr('disabled', 'disabled');
        ajax.ajaxCall(element.data().action, "POST", null, false, function (timestamp) {

            ajax.ajaxCall(element.data().action + '/check/' + timestamp, "GET", null, false, function (data) {

                element.removeAttr('disabled', 'disabled');
                if (data === 'not_existing') {
                    $('.tt-please-wait-export-visits').addClass('hide');

                    $.SmartMessageBox({
                        title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.not_existing_export_file'),
                        content: Lang.get('tripletrax.not_existing_export_file_desc'),
                        buttons: '[' + Lang.get('tripletrax.ok') + ']'
                    }, function (ButtonPressed) {
                    });
                } else {
                    // Datei herunterladen
                    window.open(element.data().action + '/download/' + data, '_blank');

                    //Datei auf PUBLIC wieder löschen (Timeout hinzugefügt, da sonst die Datei zu schnell gelöscht wird)
                    setTimeout(function() {
                        ajax.ajaxCall(element.data().action + '/delete/' + data, "POST", null, false, function (data) {});
                    }, 500);

                    $('.tt-please-wait-export-visits').addClass('hide');
                }
            });
        });
    })
}

module.exports.registerStatsEvents = registerStatsEvents;
